'use client';

import { TextField, Theme, useMediaQuery } from '@mui/material';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import OtpInput from 'react-otp-input';
export const OTPInput = ({
  value = '',
  length = 4,
  onChange,
  onDone,
  onEnter,
  inputType = 'number',
  slotProps,
  shouldAutoFocus = false,
  disabled = false
}) => {
  const [currentValue, setCurrentValue] = useState('');
  const isMobile = useMediaQuery(t => t.breakpoints.down('sm'));
  useEffect(() => {
    setCurrentValue(value);
  }, [value]);
  useEffect(() => {
    if (length === currentValue.length) {
      onDone?.(currentValue);
    }
  }, [currentValue, length, onDone]);
  const onValueChange = otp => {
    setCurrentValue(otp);
    onChange?.(otp);
  };
  const onEnterClicked = e => {
    if (!onEnter) return;
    if (e.key === 'Enter') {
      onEnter(currentValue);
    }
  };
  return <OtpInput value={currentValue} onChange={onValueChange} numInputs={length} inputType={inputType} shouldAutoFocus={shouldAutoFocus} containerStyle={{
    justifyContent: 'center',
    gap: '1rem'
  }} inputStyle={{
    height: '2rem',
    width: '2rem',
    padding: isMobile ? '8px' : undefined,
    fontSize: 20,
    fontWeight: '600',
    textAlign: 'center'
  }} renderInput={({
    style,
    ref,
    onKeyDown,
    ...props
  }) => <TextField inputRef={ref} slotProps={{
    htmlInput: {
      style,
      onKeyDown: e => {
        onEnterClicked(e);
        onKeyDown?.(e);
      },
      ...props,
      disabled,
      className: clsx(props.className, slotProps?.htmlInput?.className, 'number-input')
    }
  }} />} />;
};